import { Route } from 'react-router-dom';
import LanguageChangeScreen from '../screens/LanguageChangeScreen';
import Login from '../screens/login/Login';
import Landing from '../screens/landing/Landing';
import Register from '../screens/Register';
import Enquiry from '../screens/Enquiry';
import ComingSoon from '../screens/ComingSoon';
import OnePageModel from '../screens/supply_chain/OnePageModel';
import FullModel from '../screens/supply_chain/FullModel';
import LoginInternal from '../screens/LoginInternal';
import { HOME_PAGE } from '../globals/const';
import ViewLandNFT from '../screens/ViewNFT';
import CropTracePublic from '../screens/CropTracePublic';
import TraceabilityDemoHome from '../screens/TraceabilityDemoHome';
import ViewHarvest from '../screens/ViewHarvest';
import DemoLogin from '../screens/DemoLogin';
import CreateSubscription from '../screens/subscription/CreateSubscription';
import MySubscriptions from '../screens/subscription/MySubscriptions';
import BiocharLandingPage from '../screens/biochar/BiocharLandingPage';
import BiocharInterestForm from '../screens/biochar/BiocharInterestForm';
import RequestBiochar from '../screens/biochar/RequestBiochar';
import PaymentForm from '../screens/payments/PaymentForm';
import UserCampaigns from '../screens/campaigns/UserCampaigns';
import FPOInterestForm from '../screens/fpo/FPOInterestForm/FPOInterestForm';
import SuccessPage from '../screens/fpo/FPOInterestForm/SuccessPage';
import SoilLabsLanding from '../screens/farmer/SoilLabsLanding';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import TermsOfService from '../screens/TermsOfService';
import SupportPage from '../screens/SupportPage';
import SupportBot from '../screens/SupportBot';
import SatelliteDataReport from '../screens/farmer/satellite_data_report/SatelliteDataReport';
import ThankYouPage from '../screens/biochar/ThankyouPage';
import BiocharOrderPaymentPage from '../screens/BiocharOrderPaymentPage';
import BiocharOrderInvoicePage from '../screens/biochar/BiocharOrderInvoicePage';
import LoginInitial from '../screens/login/LoginInitial';
import AdminReportPage from '../screens/admin/AdminReportPage';
import InvoicePublicPage from '../screens/payments/InvoicePublicPage';
import AmSatelliteReport from '../screens/farmer/satellite_data_report/agro_monitoring/AmSatelliteReport';

export const publicRoutes = [
  <Route
    key="public-language-change"
    exact
    path="/language-change"
    element={<LanguageChangeScreen />}
  />,
  <Route
    key="public-login"
    path={`${HOME_PAGE}/login`}
    element={<LoginInitial />}
  />,
  <Route
    key="public-login-role-select"
    path={`${HOME_PAGE}/login-role-select`}
    element={<Login />}
  />,
  <Route
    key="public-landing"
    path={`${HOME_PAGE}/landing`}
    element={<Landing />}
  />,
  <Route
    key="public-signup"
    path={`${HOME_PAGE}/signup`}
    element={<Register />}
  />,
  <Route
    key="public-enquiry"
    path={`${HOME_PAGE}/enquiry`}
    element={<Enquiry />}
  />,
  <Route
    key="public-traceability-demo"
    path={`${HOME_PAGE}/traceability-demo`}
    element={<ComingSoon />}
  />,
  <Route
    key="public-one-page-model"
    path={`${HOME_PAGE}/one-page-model`}
    element={<OnePageModel />}
  />,
  <Route
    key="public-full-model"
    path={`${HOME_PAGE}/full-model`}
    element={<FullModel />}
  />,
  <Route
    key="public-login-internal"
    path={`${HOME_PAGE}/login-internal/`}
    element={<LoginInternal />}
  />,
  <Route key="public-view-land" path="/view-land" element={<ViewLandNFT />} />,
  <Route
    key="public-view-crop"
    path="/view-crop/:cropId"
    element={<CropTracePublic />}
  />,
  <Route
    key="public-traceability"
    path="/traceability/"
    element={<TraceabilityDemoHome />}
  />,
  <Route
    key="public-view-harvest"
    path="/view-harvest"
    element={<ViewHarvest />}
  />,
  <Route key="public-demo-login" path="/demo-login" element={<DemoLogin />} />,
  <Route
    key="public-subscribe"
    path="/subscribe"
    element={<CreateSubscription />}
  />,
  <Route
    key="public-my-subscriptions"
    path="/my-subscriptions"
    element={<MySubscriptions />}
  />,
  <Route
    key="public-biochar-campaign"
    exact
    path="/biochar-campaign"
    element={<BiocharLandingPage />}
  />,
  <Route
    key="public-biochar-interest-form"
    exact
    path="/biochar-interest-form"
    element={<BiocharInterestForm />}
  />,
  <Route
    key="public-request-biochar"
    exact
    path="/request-biochar"
    element={<RequestBiochar />}
  />,
  <Route
    key="public-payment-form"
    exact
    path="/payment-form"
    element={<PaymentForm />}
  />,
  <Route
    key="public-success-confirmation"
    exact
    path="/success-confirmation"
    element={<ThankYouPage />}
  />,
  <Route
    key="public-active-campaigns"
    path="/active-campaigns"
    element={<UserCampaigns />}
  />,
  <Route
    key="public-fpo-interest-form"
    path="/fpo-interest-form"
    element={<FPOInterestForm />}
  />,
  <Route
    key="public-success-page"
    path="/success-page"
    element={<SuccessPage />}
  />,
  <Route
    key="public-soil-testing-labs"
    exact
    path="/soil-testing-labs"
    element={<SoilLabsLanding />}
  />,
  <Route
    key="public-privacy-policy"
    path="/privacy-policy"
    element={<PrivacyPolicy />}
  />,
  <Route key="public-terms" path="/terms" element={<TermsOfService />} />,
  <Route key="public-support" path="/support" element={<SupportPage />} />,
  <Route
    key="public-support-bot"
    path="/support-bot"
    element={<SupportBot />}
  />,
  <Route
    key="public-satellite-data-report"
    path="/farmer/satellite-data-report/:encryptedId/:language/:accessKey"
    element={<SatelliteDataReport />}
  />,
  <Route
    key="public-am-satellite-report"
    path="/farmer/am-satellite-data-report/:farmId/:language/:accessKey"
    element={<AmSatelliteReport />}
  />,
  <Route
    key="public-biochar-order-details"
    path="/biochar-order-details/:biocharOrderId"
    element={<BiocharOrderPaymentPage />}
  />,
  <Route
    key="public-biochar-order-invoice"
    path="/biochar-order-invoice/:orderId/:accessKey"
    element={<BiocharOrderInvoicePage />}
  />,
  <Route
    key="invoice-public"
    path="/invoice-public/:invoiceUUID"
    element={<InvoicePublicPage />}
  />,
  <Route
    key="admin-report-detail"
    path="/admin-report/:access_key"
    element={<AdminReportPage />}
  />,
];
